import React from 'react';
import cx from 'classnames';
import styles from '../style.module.css';

export const Divider = () => {
  const styleDiv = cx('mt32 bt b--boulder mb32 o-30', styles.divider);
  return <div className={styleDiv} />;
};
